import { useState } from "react";
import { api } from "../../api/apiClient";

/**
 * G-145 (OD-224) — "Not confirmed" plus the one button that sends the
 * confirmation link, shown beside the address in the profile header until it
 * is confirmed. Also used on its own when the profile could not load, because
 * the app-wide banner steps aside on this page.
 */
export function ConfirmEmailNudge() {
  const [state, setState] = useState<"idle" | "sending" | "sent">("idle");
  const [error, setError] = useState<string | null>(null);

  const send = async () => {
    setError(null);
    setState("sending");
    try {
      await api.sendMyVerificationEmail();
      setState("sent");
    } catch (err: unknown) {
      setState("idle");
      setError(err instanceof Error ? err.message : "Could not send the link");
    }
  };

  return (
    <>
      <span className="badge warning">Not confirmed</span>
      {state === "sent" ? (
        <span className="profile-id-sent">Link sent — check your inbox</span>
      ) : (
        <button
          type="button"
          className="button profile-id-confirm"
          onClick={() => void send()}
          disabled={state === "sending"}
        >
          {state === "sending" ? "Sending…" : "Confirm my email"}
        </button>
      )}
      {error ? <span className="field-error profile-id-confirm-error">{error}</span> : null}
    </>
  );
}
